export const ThirtyDayPRTIXMock = {
    mutualFund: {
        thirtyDayAnnualizedDividendYieldAsOfDate: '2024-11-08T05:00:00Z',
        thirtyDayAnnualizedDividendYield: 3.85,
        unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
        unsubsidizedThirtyDaySECYield: 3.26,
        yield30DayStandard: 3.26,
        yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
        inceptionDate: '1989-09-29T04:00:00Z',
        __typename: 'GraphQLMutualFund'
    }
};
